import { AuthenticationService } from './../authentication/authentication.service';
import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LogLevels } from '../../types/enums';
import { ConfigService } from '../config';

@Injectable({
  providedIn: 'root',
})
export class LoggerService implements OnDestroy {
  private logQueue: { message: string; level: string; meta: any }[] = [];
  private readonly INTERVAL = 10000;
  private readonly MAX_QUEUE = 100;
  private readonly MAX_BATCH = 20;
  private flushIntervalId: ReturnType<typeof setInterval>;

  constructor(
    private http: HttpClient,
    private configService: ConfigService,
    private authenticationService: AuthenticationService
  ) {
    this.flushIntervalId = setInterval(() => {
      this.sendLogs();
    }, this.INTERVAL);
  }

  ngOnDestroy(): void {
    clearInterval(this.flushIntervalId);
  }

  private getMeta() {
    const user = this.authenticationService.getLoggedUserFromStorage();
    const customerId = this.authenticationService.getCustomerIdFromToken();
    return {
      app: this.configService.getAppName(),
      url: window.location.pathname,
      userAgent: navigator.userAgent,
      userId: user?.id || null,
      user: user?.email || '',
      customerId: customerId || null,
    };
  }

  log(message: string, level: LogLevels = LogLevels.info, meta?: any) {
    if (this.logQueue.length >= this.MAX_QUEUE) {
      this.logQueue.shift();
    }

    this.logQueue.push({
      message,
      level,
      meta: {
        ...this.getMeta(),
        ...meta,
        timestamp: new Date().toISOString(),
      },
    });
  }

  private sendLogs(): void {
    if (!this.logQueue.length) return;

    const batch = this.logQueue.splice(0, this.MAX_BATCH);
    const url = this.configService.endpoints.logs;

    this.http.post(url, { logs: batch }).subscribe();
  }
}
